/**
 * Castle & Key BottleNexus Integration
 * Controls visibility of native Shopify ATC vs BottleNexus buy button
 * based on product type (spirits vs non-spirits) and user's state.
 *
 * Exempt states can use native Shopify checkout for spirits.
 * No-ship states have no legal path at all and get no buy option.
 * All other states must use BottleNexus third-party checkout.
 */
(function () {
  var EXEMPT_STATES = ['KY', 'NE', 'NH', 'ND', 'WA'];

  // States we cannot ship spirits to by any route. BottleNexus has no fulfillment
  // path here, so neither native checkout nor the BottleNexus button is offered.
  // These visitors can still browse the site — only the buy path is closed.
  var NO_SHIP_STATES = ['AR', 'MI', 'UT'];

  function inList(list, state) {
    if (!state) return false;
    return list.indexOf(state.toUpperCase()) !== -1;
  }

  function applyRules() {
    var ctx = document.getElementById('bnx-product-ctx');
    if (!ctx) return;

    var isSpirits = ctx.getAttribute('data-is-spirits') === 'true';
    var restricted = ctx.getAttribute('data-restricted') === 'true';
    var sectionId = ctx.getAttribute('data-section-id') || '';
    var wrap = document.getElementById('bnx-buy-wrap-' + sectionId);
    var msg = document.getElementById('bnx-unavailable-' + sectionId);

    function hideMsg() { if (msg) msg.hidden = true; }

    // Non-spirits: always show native ATC, hide BNX
    if (!isSpirits) {
      document.documentElement.removeAttribute('data-bnx-hide-actions');
      if (wrap) wrap.style.display = 'none';
      hideMsg();
      return;
    }

    // Spirits: check state
    var state = '';
    try { state = localStorage.getItem('bn_state') || ''; } catch (e) {}
    var known = !!state;

    // No-ship state: no legal checkout path exists, so close both buy options and
    // say why. Checked before the exemption so a blocking rule always wins.
    if (inList(NO_SHIP_STATES, state)) {
      document.documentElement.setAttribute('data-bnx-hide-actions', '1');
      if (wrap) wrap.style.display = 'none';
      if (msg) msg.hidden = false;
      return;
    }

    // Exempt state: native Shopify checkout is allowed for all spirits
    if (inList(EXEMPT_STATES, state)) {
      document.documentElement.removeAttribute('data-bnx-hide-actions');
      if (wrap) wrap.style.display = 'none';
      hideMsg();
      return;
    }

    // Non-exempt or unknown: native ATC is not allowed
    document.documentElement.setAttribute('data-bnx-hide-actions', '1');
    if (restricted) {
      // No BottleNexus option exists for this product — there's no way to sell it
      // here. Surface the message only for a confirmed non-exempt state; an unknown
      // state stays quiet (the visitor hasn't told us where they are yet).
      if (wrap) wrap.style.display = 'none';
      if (msg) msg.hidden = !known;
    } else {
      if (wrap) wrap.style.display = '';
      hideMsg();
    }
  }

  // Run on load and on state change
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyRules);
  } else {
    applyRules();
  }
  document.addEventListener('bn:context:changed', applyRules);
})();
